export const uploadImagesSelector = state => state.uploadImages;
